module.exports = __webpack_public_path__ + "09_face.2e8494e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer1/09_face.png
// module id = A7vX
// module chunks = 0